module.exports = __webpack_public_path__ + "static/media/sms-cskh.d7965c72.jpg";